import { Objectclass } from '@yes.technology/react-toolkit'
import { CellValue, MapColumnToAction } from '../../../types'

type UseCustomTableCellProps = {
  value: CellValue
  columnName: string
  objectclass?: Objectclass
  mapColumnToAction?: MapColumnToAction
}

export enum CustomActions {
  link_action = 'link_action'
}

type ActionProps = {
  type: CustomActions
  url: string
  target: string
  label?: string
  style?: React.CSSProperties
}

const useCustomTableCell = ({
  value,
  columnName,
  objectclass,
  mapColumnToAction
}: UseCustomTableCellProps) => {
  return Object.entries(mapColumnToAction ?? {}).reduce(
    (acc: ActionProps | null, [mappedColumnName, customActionAttributes]) => {
      if (mappedColumnName === columnName) {
        const relationName = customActionAttributes?.relationName
        const relationObjectClassUuid =
          objectclass?.relation_classes?.[relationName]?.uuid_objectclass || ''

        let url = customActionAttributes?.link?.url || ''

        if (!!value && relationObjectClassUuid) {
          url += `?object-uuid=${value}&uuid_objectclass=${relationObjectClassUuid}`
        }

        const action = {
          type: CustomActions.link_action,
          url: url,
          label: customActionAttributes?.label || '',
          target: customActionAttributes?.link?.target ?? '_blank',
          style: customActionAttributes?.style || {}
        }

        acc = action
      }

      return acc
    },
    null
  )
}

export default useCustomTableCell
